import { AccountData, PassOrderPageData, PassScheduleSelectionType, PassType } from '../../../api';
import { getPassOrderPagesUsingOrderPage } from '../../../utils/AccountUtils';

export const eventSupportsPassHolds = (account: AccountData, orderPageId: string): boolean =>
  getPassOrderPagesUsingOrderPage(account, orderPageId).some(
    (passOrderPage: PassOrderPageData) =>
      passOrderPage.pass_type === PassType.FIXED_SCHEDULE_MONTHLY ||
      passOrderPage.schedule_selection_type === PassScheduleSelectionType.WEEKLY_SLOTS,
  );
